export class AppError extends Error {
  status?: string
  constructor({ message, status }: { message?: string; status?: string }) {
    super(message)
    this.status = status
  }
}
